import React from "react";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import CodeRoundedIcon from "@mui/icons-material/CodeRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import "./Contact.scss";

function Contact() {
  const links = [
    { icon: <PhoneRoundedIcon />, label: "Phone", value: "+91 99270 99040", href: "tel:+919927099040" },
    { icon: <EmailRoundedIcon />, label: "Email", value: "mihirsaini25@gmail.com", href: "mailto:mihirsaini25@gmail.com" },
    { icon: <GitHubIcon />, label: "GitHub", value: "mihir224", href: "https://github.com/mihir224" },
    {
      icon: <LinkedInIcon />,
      label: "LinkedIn",
      value: "mihir-saini-3680a481",
      href: "https://www.linkedin.com/in/mihir-saini-3680a481/",
    },
    { icon: <CodeRoundedIcon />, label: "LeetCode", value: "mihir224", href: "https://leetcode.com/mihir224" },
  ];

  const skillGroups = [
    { title: "Languages", items: ["Java", "Go", "Python", "TypeScript", "JavaScript", "C++", "SQL"] },
    {
      title: "Frontend",
      items: ["React.js", "Next.js", "React Native", "Redux", "Zustand", "Tailwind", "Three.js", "Vite", "MapLibre", "Mapbox", "Micro-frontends"],
    },
    {
      title: "Backend",
      items: ["Node.js", "Fastify", "Express.js", "NestJS", "FastAPI", "REST APIs", "gRPC", "WebSockets", "SSE", "AG-UI", "OAuth2", "WebRTC"],
    },
    {
      title: "Databases & Infra",
      items: [
        "PostgreSQL",
        "MongoDB",
        "Redis",
        "DuckDB",
        "ClickHouse",
        "Docker",
        "Kubernetes",
        "Istio",
        "Jenkins",
        "ArgoCD",
        "GitHub Actions",
        "Git Flow",
        "OIDC",
        "Entra",
        "AWS S3",
        "EKS",
        "ECS",
        "DynamoDB",
        "CloudFront",
        "Lambda",
        "Bedrock",
        "AgentCore",
        "ECR",
        "SQS",
      ],
    },
    {
      title: "AI / Distributed Systems",
      items: ["RAG", "MCP", "LangGraph", "LangChain", "Strands", "VectorDB", "Pinecone", "Milvus", "Multi-Agent Systems", "Event-Driven Architecture", "Caching", "DLQs", "Retry Systems", "Observability"],
    },
    { title: "Tools", items: ["Codex", "Git", "Swagger", "Postman", "Linux", "VS Code", "Claude Code", "Cursor", "Kibana", "Power BI", "Firecrawl", "IntelliJ"] },
  ];

  const education = {
    degree: "B.Tech, Electronics and Communication Engineering",
    school: "Jaypee Institute of Information Technology",
    period: "2020 – 2024",
    detail: "CGPA 8.0 · Noida, India",
  };

  const achievements = [
    "Won 1st place at EagleView Hackathon for NeuraMap, an agentic mapping system",
    "Received EagleView Spotted Eagle Award for Q4 2024 performance",
    "Solved 500+ problems on LeetCode",
  ];

  return (
    <div className="contact section-shell">
      <div className="section-heading">
        <div>
          <span className="section-kicker">Contact and toolbox</span>
          <h2>Builder across UI, systems, and AI</h2>
        </div>
        <p>
          Most of the work sits at the intersection of product experience and backend reliability: fast interfaces, resilient
          APIs, mapped data, streaming workflows, and practical AI tools.
        </p>
      </div>

      <div className="contact__layout">
        <div className="contact__panel">
          <h3>Reach out</h3>
          <p>
            Best reached by email or LinkedIn for engineering conversations around platforms, geospatial products, webhook systems, cross-platform tooling, and agentic AI workflows.
          </p>

          <div className="contact__links">
            {links.map((link) => (
              <a key={link.href} href={link.href} target={link.href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
                <span className="contact__link-icon">{link.icon}</span>
                <span>
                  <strong>{link.label}</strong>
                  <small>{link.value}</small>
                </span>
                <ArrowOutwardRoundedIcon fontSize="small" />
              </a>
            ))}
          </div>

          <div className="contact__education">
            <h3>Education</h3>
            <p>
              <strong>{education.degree}</strong>
              <span>
                {education.school} · {education.period}
              </span>
              <span>{education.detail}</span>
            </p>
          </div>
        </div>

        <div className="contact__skills">
          {skillGroups.map((group) => (
            <section className="contact__skill-group" key={group.title}>
              <h3>{group.title}</h3>
              <div>
                {group.items.map((item) => (
                  <span key={item}>{item}</span>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>

      <div className="contact__achievements" aria-label="Achievements">
        {achievements.map((achievement) => (
          <span key={achievement}>{achievement}</span>
        ))}
      </div>
    </div>
  );
}

export default Contact;
